import React from 'react';

import Tag from './AbstractTag';

Tag.parser.registerTag(
  'u',
  class extends Tag {
    constructor(renderer, settings = {}) {
      super(renderer, settings);
    }

    toReact() {
      return <u>{this.getComponents()}</u>;
    }
  }
);
